<div *ngIf="zone === 'onboarding'" class="col element-zoom m-0" [ngStyle]="contentStyle">
  <div
    class="widget-wrapper"
    [ngClass]="isStepComplete ? 'step-complete' : isError ? 'error' : 'open'"
    style="min-height: 100%"
    [ngStyle]="borderStyle"
  >
    <div class="title-wrapper">
      <div class="title">
        <p [ngStyle]="colorTextAlignStyle">
          <span [innerHTML]="widgetConfig.attributes['sub_heading'] | safeHtml"> </span>
        </p>
      </div>
      <div class="steps-count-wrapper">
        <span *ngIf="isStepComplete && nameForm.valid && isNameShowSuccessIcon">
          <img src="assets/images/check-circle.svg" alt="check-circle" class="img-fluid" />
        </span>
        <span *ngIf="!isStepComplete && isError && isNameShowErrorIcon">
          <img
            (click)="showErrorMsg()"
            src="assets/images/exclamation-circle.svg"
            alt="check-circle"
            class="cursor-pointer img-fluid"
          />
        </span>
      </div>
      <div *ngIf="!isStepComplete && isError && isShowErrorMsg" class="error-msg">
        <img src="assets/images/exclamation-circle.svg" alt="check-circle" class="img-fluid" />
        <label>Full name required</label>
        <p>You need to provide your first name, last name.</p>
      </div>
    </div>
    <div class="form-wrapper">
      <form [formGroup]="nameForm">
        <div class="form-group" *ngFor="let field of widgetConfig.attributes['field_attributes']">
          <ng-container *ngIf="field.type !== 'dropdown'">
            <ng-container
              *ngTemplateOutlet="nameInput; context: { field: field, formGroup: nameForm }"
            ></ng-container>
          </ng-container>
        </div>
        <div class="error-wrapper">
          <div
            class="text-error"
            *ngIf="nameForm.get('first_name')?.invalid && nameForm.get('first_name')?.touched"
          >
            <img src="assets/images/exclamation-circle.svg" alt="check-circle" class="img-fluid" />
            <p *ngIf="nameForm.get('first_name')?.hasError('required')">First name is a required field</p>
            <p *ngIf="nameForm.get('first_name')?.hasError('noNumbers')">
              First name cannot include numbers.
            </p>

            <p *ngIf="nameForm.get('first_name')?.hasError('noSpecialChars')">
              First name cannot include special characters.
            </p>
          </div>
          <div
            class="text-error"
            *ngIf="nameForm.get('middle_name')?.invalid && nameForm.get('middle_name')?.touched"
          >
            <img src="assets/images/exclamation-circle.svg" alt="check-circle" class="img-fluid" />
            <p *ngIf="nameForm.get('middle_name')?.hasError('noNumbers')">
              Middle name cannot include numbers.
            </p>

            <p *ngIf="nameForm.get('middle_name')?.hasError('noSpecialChars')">
              Middle name cannot include special characters.
            </p>
          </div>
          <div
            class="text-error"
            *ngIf="nameForm.get('last_name')?.invalid && nameForm.get('last_name')?.touched"
          >
            <img src="assets/images/exclamation-circle.svg" alt="check-circle" class="img-fluid" />
            <p *ngIf="nameForm.get('last_name')?.hasError('required')">Last Name is a required field</p>
            <p *ngIf="nameForm.get('last_name')?.hasError('noNumbers')">Last name cannot include numbers.</p>

            <p *ngIf="nameForm.get('last_name')?.hasError('noSpecialChars')">
              Last name cannot include special characters.
            </p>
          </div>
        </div>
        <div
          class="form-group m-0 is-hidden"
          style="position: fixed; bottom: 1em; left: 1em; width: calc(100% - 2em)"
        >
          <finx-button
            type="button"
            class="btn w-100 mt-2"
            labeltext="Confirm"
            (click)="onSubmit()"
          ></finx-button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- desgin for name  -->

<div
  *ngIf="zone === 'profile' || zone === 'verification' || dynamicZone"
  class="col element-zoom profile-page"
  [ngStyle]="combinedContentAndBorderStyles"
  style="height: 100%"
>
  <div class="form-wrapper" style="height: 100%">
    <div *ngIf="zone === 'profile'" class="col-12"></div>

    <form [formGroup]="nameForm" class="h-100">
      <div class="row" [ngClass]="{ 'is-vertical-align': dynamicZone }">
        <div
          class="float-left"
          [ngClass]="zone === 'verification' || columnStyle ? 'col-12' : 'col-6'"
          *ngFor="let field of fieldAttributes; let index = index"
        >
          <ng-container *ngIf="field.type !== 'dropdown'">
            <ng-container
              *ngTemplateOutlet="nameInput; context: { field: field, formGroup: nameForm, index: index }"
            ></ng-container>
          </ng-container>
        </div>
      </div>
    </form>

    <div *ngIf="zone === 'profile'" class="col-12"></div>
  </div>
</div>
<ng-template #nameInput let-field="field" let-formGroup="formGroup" let-index="index">
  <div [formGroup]="formGroup">
    <finxone-platform-label-input
      [type]="field.type"
      class="profile-input"
      [formControlName]="field.name"
      [value]="nameForm.get(field.name)?.value ?? ''"
      [label]="field.label"
      [formGroup]="nameForm"
      [labelAsPlaceholder]="pageConfig?.labelsAsPlaceholder"
      [colorTextAlignStyle]="colorTextAlignStyle"
      [textInputFontStyle]="textInputFontStyle"
      (keyup)="valueChangesTrigger()"
      [inputStyle]="currentInputStyle[field.name]"
      (focusEvent)="updateInputFieldCurrentStyles($event, field.name)"
    ></finxone-platform-label-input>
  </div>
</ng-template>
